/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Layout type of the ports
 */
export type PortLayout = (typeof PortLayout)[keyof typeof PortLayout];

export const PortLayout = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
